$(document).ready(function () {
    $('.story-snippet-title-and-desc')
        .find('.read-btn')
        .on('click', function () {
            var top;
            if ($('.story-details').length > 0) {
                top = $('.story-details').offset().top - $('.sticky-header').innerHeight();
            } else {
                top = $('.collection-details').offset().top - $('.sticky-header').innerHeight();
            }
            $('html, body').animate(
                {
                    scrollTop: top
                },
                500
            );
        });
});
